export const Components = {
    dropBox: [
        'texto',
        'border',
        'background',
        'contorno',
        'multiplo'
    ],
    alternativa:[
        'texto',
        'border',
        'background',
        'contorno',
        'dropBoxes',
        'acessibilidadeImagem',
        'imagem'
    ],

    texto:  [
        'texto',
        'border',
        'background',
        'contorno',
    ],
    video: [
        'url'
    ],
    imagem:[
        'imagem',
        'border'
    ],

    checkBox: ['correta']

}